<template>
  <div id="app">
  <nav>
    <div class="nav">
      <div>
        <img src="./assets/guiwei-logo/公司logo.png" alt="" @click="imclick()">
      </div>
      <div>
        <router-link to="/">首页</router-link>
        <router-link to="/aboutus">关于我们</router-link>
        <router-link to="/Introd">产品介绍</router-link>
        <router-link to="/cases">成功案例</router-link>
        <router-link to="/cont">联系我们</router-link>
      </div>
    </div>
  </nav>

  <main>
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </main>

  <footer>
    <InformationView />
    <UnderView />
  </footer>
</div>
</template>
<script setup>
import InformationView from './components/Information.vue';
import UnderView from "./views/UnderView.vue";
import { useRouter } from 'vue-router';
const router = useRouter()
const imclick = (() => {
  router.replace('/')
})
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

body {
  background: #F4F4F4;
}

nav {
  position: sticky;
  top: 0;
  z-index: 9999;

  .nav {
    display: flex;
    justify-content: space-evenly;
    background-color: #252533;
    height: 54px;
    color: white;
    line-height: 54px;

    a {
      color: white;
      margin: 0 32px;
      text-decoration: none;
      display: inline-block;
      height: 20px;
      font-size: 16px;
      font-family: Source Sans Pro-Regular, Source Sans Pro;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 19px;

    }

    img {
      vertical-align: middle;
      height: 35px;
      cursor: pointer;
    }


    .el-tabs__active-bar {
      background-color: #ffffff !important; //切换活动项的长条颜色
      padding: 0 16px;
      box-sizing: border-box !important;
      background-clip: content-box !important;
      text-align: center;
      background-image: linear-gradient(90deg, transparent 0, transparent 30%,
          #fff 0, #fff 73%,
          transparent 0, transparent)
    }

    .el-tabs__item {
      padding: 28px 39px !important;
      height: 54px;
      font-size: 14px !important;
      vertical-align: bottom;
      color: white !important;
      vertical-align: middle;
    }
  }

  // 轮播图指示器

}

// @media only screen and (max-width: 1400px) {
//     body {
//         font-size: 20px;
//     }
// }
.router-link-active {

  border-bottom: 1px solid;
  color: white;
  padding-bottom: 16px;
}


.el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;
  background: transparent;
  background: #959595;
  border-radius: 50%;
  opacity: 0.5;
}

.el-carousel__indicator--horizontal .is-active .el-carousel__button {
  width: 10px;
  height: 10px;
  background: #333333;
  border-radius: 50%;
  opacity: 1;
}
</style>

